import React, { useEffect , useState } from 'react';

import {
  Card,
  CardHeader ,
  CardBody, 
  CardTitle, 
  CardText, 
  CardSubtitle, 
  Button,
  Container,
  Row,
  Col,
  Input,
  Label,
  Form,
  FormGroup
} from 'reactstrap';

import axios from 'axios';
import { useForm } from "react-hook-form"

import { SubmitButton , FormInput } from '../../components/MyForm'
import ContentWrapper from  '../../components/Layout/ContentWrapper'
import ContactUsForm from  './ContactUsForm'
import ConfirmSubmit from  './ConfirmSubmit'

import { contact_us_endpoint } from "../../libs/endpoints";
import BreadCrumbs from '../../layouts/breadcrumbs/BreadCrumbs';

const ContactUs = () => {

  const [view_index , set_view_index] = useState(1)

  function next_view() {
      console.log('next_view has been called!')
      set_view_index(view_index+1)
  }

  return (
    <>


<ContentWrapper colspan='6'>
       <BreadCrumbs /> 

    { view_index === 1 && (<ContactUsForm next_view={next_view}/>)}
    { view_index === 2 && (<ConfirmSubmit />)}


</ContentWrapper>
    </>
  )
}

export default ContactUs;
